import * as React from 'react';
import { OnboardingTooltip } from '@cian/ui-kit';

import { useChatOnboarding } from './hooks/useChatOnboarding';
import { ChatOnboardingContent } from '../../components/ChatOnboardingContent';
import { TChatOnboardingType } from '../../types/chatOnboarding';

interface IChatOnboardingContainerProps {
  children: React.ReactElement;
  type: TChatOnboardingType;
  theme?: 'black' | 'blue';
}

export const ChatOnboardingContainer: React.FC<IChatOnboardingContainerProps> = ({
  children,
  type,
  theme = 'black',
}) => {
  const { open, closeHandler, onboardingText } = useChatOnboarding(type);

  const isContentWide = type !== 'builder';

  return (
    <OnboardingTooltip
      theme={theme}
      content={<ChatOnboardingContent wide={isContentWide}>{onboardingText}</ChatOnboardingContent>}
      placement="top-end"
      portal={false}
      open={open}
      onClose={closeHandler}
      flip={false}
    >
      <div>{children}</div>
    </OnboardingTooltip>
  );
};
